import {defineAction} from 'redux-define';
import {createAction} from 'redux-actions';
import {browserHistory} from 'react-router';
import {put, takeLatest, select, take, call} from 'redux-saga/effects';

import {acceptInviteSaga} from 'api/invite';
import {getDeal, selectDeal} from 'api/deals';
import {getUserInfoSaga} from 'api/users';

import {selectEnv} from 'reducers/env';

import {persist} from '../reducer';

const namespace = 'flows/interest/deal';

// Actions
const LOAD_INTEREST_DEAL = defineAction('LOAD_INTEREST_DEAL', namespace);
const SUBMIT_INTEREST_DEAL = defineAction('SUBMIT_INTEREST_DEAL', namespace);

export const loadInterestDeal = createAction(LOAD_INTEREST_DEAL.ACTION);
export const submitInterestDeal = createAction(SUBMIT_INTEREST_DEAL.ACTION);

// Interest Deal Saga
export function* interestDealSaga({payload}) {
  const {invite, deal, after, confirmationToast} = payload;

  // Save deal and invite id
  yield put(persist({invite, deal, after: atob(after), confirmationToast}));

  // Accept invite
  yield call(acceptInviteSaga, {payload: {id: invite.id}});

  // Load up user now that the user is definitely created
  yield call(getUserInfoSaga);

  // Load deal, unless already loaded
  const cachedDeal = yield select(selectDeal, deal.id);
  if (!cachedDeal || !cachedDeal.loaded) {
    yield put(getDeal(deal));
  }

  // Wait for user to click invest
  yield take(SUBMIT_INTEREST_DEAL.ACTION);

  // Take them to the next page
  const env = yield select(selectEnv);
  if (env.web) {
    yield call(browserHistory.push, '/interest/investor');
  }
}

export function* sagas() {
  yield takeLatest(LOAD_INTEREST_DEAL.ACTION, interestDealSaga);
}



// WEBPACK FOOTER //
// ./mobile/shared/flows/interest/deal/index.js